import { InfoCircleFilled } from '@ant-design/icons';
import { Collapse } from 'antd';
import clsx from 'clsx';
import React from 'react';
import { Trans } from 'react-i18next';

interface InfoCollapseI18nProps {
  i18nKey: string;
  className?: string;
}

interface InfoCollapseChildrenProps {
  label?: string;
  children: React.ReactNode;
}

type InfoCollapseProps = InfoCollapseI18nProps | InfoCollapseChildrenProps;

/**
 * Composant `InfoCollapse` qui affiche une section repliable avec une icône d'information
 * et un texte traduit basé sur une clé i18n.
 *
 * @param {string} props.i18nKey - La clé i18n utilisée pour afficher le texte traduit.
 * @param {React.ReactNode} props.children - Le contenu de la section repliable.
 */
export default function InfoCollapse(props: InfoCollapseProps) {
  return (
    <Collapse
      expandIconPosition="end"
      className={clsx((props as InfoCollapseI18nProps).className, 'p-2')}
      rootClassName="[&_.ant-collapse-header]:!py-0 bg-white [&_.ant-collapse-content]:bg-transparent [&_.ant-collapse-content]:border-none [&_.ant-collapse-content-box]:!pt-0"
      defaultActiveKey={['1']}
      items={[
        {
          key: '1',
          label: (props as InfoCollapseChildrenProps).label,
          children: (props as InfoCollapseChildrenProps).children ?? (
            <div className="flex gap-2">
              <div>
                <InfoCircleFilled className="text-bleu-info" />
              </div>
              <div>
                <Trans
                  i18nKey={(props as InfoCollapseI18nProps).i18nKey}
                  shouldUnescape={true}
                />
              </div>
            </div>
          ),
        },
      ]}
    />
  );
}
